<template>
    <div class="home">
       <Topbar />
       <div class="container-fluid text-left pl-2 pr-2 d-flex justify-content-center mt-5 pt-4">
            <div class="card shadow mb-4 col-md-6 m-0 p-0">
                <div class="card-header py-1" :style="{ backgroundColor: moduloAtual().color }">
                    <h6 class="m-0 font-weight-bold text-white">
                        Selecione o inventário

                        <div v-show="carregando" class="spinner-grow">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </h6>
                </div>
                <fieldset :disabled="carregando">
                    <div class="card-body bg-light text-primary-dark pl-2 pr-2 small">
                        
                        <div class="form-group text-center col-auto mb-0">
                            <div class="btn-group w-100">
                                <input
                                    class="form-control form-control-sm"
                                    name="pesquisa"
                                    id="pesquisa"
                                    label="Pesquisa"
                                    type="text"
                                    autocomplete="off"
                                    placeholder="Buscar inventário"
                                    @keydown.enter="(e) => filtrar(e.target.value)"
                                    inputmode="numeric"
                                />
                                <button @click="list" type="button" class="btn btn-primary btn-sm">
                                    <img style="height: 13px;" src="../assets/sync-alt-solid.svg" alt="">
                                </button>
                            </div>
                        </div>

                        <div class="text-center" v-if="this.inventarioBuscaError">
                            <span class="text-danger">{{ this.inventarioBuscaError }}</span>
                        </div>

                        <div class="form-group text-center col-auto mt-2">
                            <button class="btn btn-primary btn-block btn-sm" data-toggle="collapse" data-target="#collapse1">
                                Adicionar novo Inventário
                                <em class="fa fa-arrow-down ml-2"></em>
                            </button>
                        </div>

                        <div class="form-group text-center col-auto collapse" id="collapse1">
                            <div class="btn-group w-100">
                                <select class="form-control form-control-sm" id="cliente">
                                    <option value="">
                                        -- Selecione o Cliente --
                                    </option>
                                    <option v-for="option in clientes" :value="option.idclientes" :key="option.idclientes">
                                        {{ option.fantasia }}
                                    </option>
                                    
                                </select>
                                
                                <button  @click="() => ConfirmAddInventary()" type="button" class="btn btn-primary btn-sm">
                                    <em class="fa fa-plus-circle"></em>
                                </button>
                            </div>
                            <div class="text-center mt-1" v-if="this.clienteNaoSelecionado">
                                <span class="text-danger">Selecione um cliente!</span>
                            </div>
                        </div>

                        <div class="small">
                            <table class="table table-hover table-striped table-bordered small">
                                <caption></caption>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Cliente</th>
                                        <th class="text-center">Data</th>
                                        <th class="text-center">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item) in inventarios" :key="item.idprot_inventarios">
                                        <td class="p-1">
                                            <span class="text-left font-weight-bold">
                                                <router-link :to="'/inventario/detalhes/' + item.idprot_inventarios">{{ item.idprot_inventarios }}</router-link>
                                            </span>
                                        </td>
                                        <td class="p-1"><span class="text-left small">{{ item.fantasia }}</span></td>
                                        <td class="p-1 text-center small"><span>{{ formatDate(item.dataabertura) }}</span></td>
                                        <td class="p-1 text-center small">
                                            <div :class="[item.class]">
                                                <span>{{ item.aberto == 0 ? 'Aberto' : 'Fechado' }}</span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                           
                        </div>
                        
                    </div>
                </fieldset>
            </div>
        </div> 
        <LogoutModal/>

        <Modal
            id="modalAddInventary"
            title="Confirme:"
            :confirmFunction="() => okAddInventary()"
            :carregando="carregando"
        >
            Deseja adicionar um novo inventário?
        </Modal>
    </div>
</template>

<script>
// @ is an alias to /src
import Topbar from '@/components/Topbar.vue'
import LogoutModal from '@/components/LogoutModal.vue'
import ViewMixin from './ViewMixin'
import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'
import api from '../services/api'
import api_inventario from '../services/api-inventario'
import Modal from "../components/Modal.vue";
import $ from "jquery";
import { selecionar } from '../utils'
import audioService from '@/services/audioService.js';

export default {
    name: 'Inventario',
    mixins: [
        ViewMixin
    ],
    components: {
        Topbar,
        LogoutModal,
        Modal,
    },

    data: () => {
        return {
            clientes: [],
            inventarios: [],
            dados: [],
            inventarioBuscaError: '',
            clienteNaoSelecionado: false,
        };
    },

    async mounted() {
        try {
            await this.validarToken();
            await this.list();
            await this.listarClientes();
            setTimeout(() => {
                selecionar('#pesquisa')
            }, 100);
        } catch (e) {
            if (e instanceof TokenInvalidoException) {
                this.handleTokenInvalidoException();
            } else if (e instanceof ServerErrorException) {
                alert(e.message);
            } else {
                alert(DEFAULT_ERROR_MESSAGE);
            }      
        }
    },

    methods: {
        playSound() {
            audioService.ops();
        },

        formatDate(dateString) {
            const date = new Date(dateString);
            return date.toLocaleDateString('pt-BR');
        },

        filtrar(idInventario = null) {

            this.inventarios = [];
            this.inventarioBuscaError = '';

            if (idInventario !== null || idInventario !== "") {
                for (const item of this.dados.clientes) {
                    if (item.idprot_inventarios == idInventario) {
                        this.inventarios.push(item);
                        break;
                    }
                }

                if (this.inventarios.length === 0) {
                    this.inventarioBuscaError = 'Invetário não encontrado';
                    this.playSound();

                }
            } else {
                this.inventarioBuscaError = 'Informe o número do inventário';
                this.inventarios = this.dados.clientes;
            }

            let pesquisaInput = document.getElementById('pesquisa');
            pesquisaInput.select();
            pesquisaInput.focus();
        },

        async validarToken() {
        this.carregando = true;

        await api.get("/validar-token");

        this.carregando = false;
        },

        async list() {
            this.carregando = true;
            this.inventarios = [];
            this.inventarioBuscaError = '';

            try {
                let response = await api_inventario.get(`/inventarios`, {
                    headers: {
                        'Cache-Control': 'no-cache',
                        'Pragma': 'no-cache',
                        'Expires': '0'
                    }
                });
                response.data.clientes.forEach((e) => {
                    if (e.aberto == 0) {
                        e["class"] = "aberto";
                    } else {
                        e["class"] = "fechado";
                    }

                    this.inventarios.push(e)
                }, this);
                this.dados = response.data;
                document.getElementById('pesquisa').value = "";
            } catch (e) {
                console.error(e);
            }
            this.carregando = false;
        },

        async listarClientes() {
            this.carregando = true;
            this.clientes = [];
            
            try {
                let response = await api_inventario.get(`/clientes`);
                response.data.clientes.forEach((e) => {
                    this.clientes.push(e)
                }, this);
            } catch (e) {
                console.error(e);
            }
            this.carregando = false;
        },

        ConfirmAddInventary() {

            let id = document.getElementById('cliente').value
            if (id == "") {
                this.clienteNaoSelecionado = true;
            } else {
                this.clienteNaoSelecionado = false;
                setTimeout(() => {
                    $("#modalAddInventary").modal('show');
                }, 100);
            }
        },

        async okAddInventary() {
            this.carregando = true;
            $("#modalAddInventary").modal('hide');
            
            try {
                let idCliente = document.getElementById('cliente').value
                let response = await api_inventario.get(`/inventario/adicionar/${idCliente}`);
                
                if (response.status === 200) {
                    await this.list();
                    let id = response.data.id;
                    this.$router.push(`/inventario/detalhes/${id}`);
                }
            } catch (e) {
                console.error(e);
            }
            this.carregando = false;
        }
    }
}
</script>

<style scoped lang="scss">
    .spinner-grow {
        width: 1em;
        height: 1em;
    }

    .aberto {
        width: 50px;
        background-color: #28A745;
        padding-top: 1px;
        padding-bottom: 1px;
        text-align: center;
        border-radius: 10px 10px;
        color: #FFF;
        margin: auto;
    }

    .fechado {
        width: 50px;
        background-color: #DC3545;
        padding-top: 1px;
        padding-bottom: 1px;
        text-align: center;
        border-radius: 10px 10px;
        color: #FFF;
        margin: auto;
    }
</style>
